import { validateForUI } from 'common/helpers/jsonValidator';

const wishSchema = {
  type: 'object',
  properties: {
    wishQuantity: { type: 'integer' }
  },
  required: ['wishQuantity'],
  additionalProperties: false
};

export const validateAllocationWish = (wish) => {
  const errors = validateForUI(wishSchema, wish);
  return errors;
};
